import { render } from "./SidebarSchools.vue?vue&type=template&id=186f5541"
import script from "./SidebarSchools.vue?vue&type=script&lang=js"
export * from "./SidebarSchools.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__